import ApplePay from "@assets/images/apple_pay_payment.svg";
import Blik from "@assets/images/blik_payment.svg";
import PayPal from "@assets/images/pay_pal_payment.svg";
import type { Dispatch, SetStateAction } from "react";
import OtpInput from "../OtpInput/OtpInput";
import PaymentMethodTile from "../PaymentMethodTile/PaymentMethodTile";
import styles from "./PaymentMethodPicker.module.scss";

export const PAYMENT_METHODS = ["Apple Pay", "Blik", "PayPal"] as const;
export type PaymentMethodName = (typeof PAYMENT_METHODS)[number];

interface PaymentMethodPickerProps {
  selected: string | null;
  onSelect: (method: string | null) => void;
  blikCode: string;
  setBlikCode: Dispatch<SetStateAction<string>>;
}

const ICONS: Record<PaymentMethodName, string> = {
  "Apple Pay": ApplePay,
  Blik: Blik,
  PayPal: PayPal,
};

/** The three payment tiles plus the Blik code input, shared by both flows. */
function PaymentMethodPicker(props: PaymentMethodPickerProps) {
  const { selected, onSelect, blikCode, setBlikCode } = props;

  const toggle = (method: string) =>
    onSelect(selected === method ? null : method);

  return (
    <div className={styles.paymentMethodsContainer}>
      {PAYMENT_METHODS.map((method) => (
        <div key={method}>
          <PaymentMethodTile
            paymentMethodName={method}
            paymentMethodIcon={
              <img
                src={ICONS[method]}
                alt={method}
                className={styles.paymentMethodIcon}
              />
            }
            selected={selected === method}
            onSelect={() => toggle(method)}
          />
          {method === "Blik" && selected === "Blik" ? (
            <div className={styles.blikCodeWrapper}>
              <OtpInput otp={blikCode} setOtp={setBlikCode} />
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}

export default PaymentMethodPicker;
